module.exports = __webpack_public_path__ + "static/media/plus.c29e8aff.svg";